import { DenormalizedCustomizableQuestion } from '@packages/types'
import React from 'react'

import * as customizationUtils from 'customizer/customization/utils'

import ThumbnailAnswer from '../answer/ThumbnailAnswer'
import ScrollableAnswersRow from './ScrollableAnswersRow'

interface ThumbnailQuestionProps {
  className?: string
  question: DenormalizedCustomizableQuestion
  pricing: { [answerId: string]: number | string }
  currency: string
  lang?: string
  country?: string
  requiredWarning?: boolean
  isLarge: boolean
  selectAnswer: (answerId: string) => void
  themeConfig: { showLabel: boolean }
  answersOutOfStock: string[]
}

const ThumbnailQuestion = ({
  question,
  pricing,
  currency,
  lang,
  country,
  selectAnswer,
  isLarge,
  themeConfig,
  answersOutOfStock,
}: ThumbnailQuestionProps) => {
  const { answers, selectedAnswer, selectedAnswers, isMultiAnswer } = question

  const handleAnswerClick = (answerId: string) => selectAnswer(answerId)

  const isDisabled = !!isMultiAnswer && customizationUtils.countSelectionsLeft(question) === 0

  return (
    <ScrollableAnswersRow
      classNameModifiers={[question.type]}
      selectedAnswerId={isMultiAnswer ? selectedAnswers?.map(({ id }) => id) : selectedAnswer?.id}
      key={question.id}
    >
      {answers.map(answer => {
        const isSelected = isMultiAnswer
          ? !!selectedAnswers?.find(({ id }) => id === answer.id)
          : answer.id === selectedAnswer?.id

        const isOutOfStock = answersOutOfStock.includes(answer.id)

        return (
          <ThumbnailAnswer
            key={answer.id}
            {...answer}
            selected={isSelected}
            handleClick={handleAnswerClick}
            price={pricing?.[answer.id]}
            isLarge={isLarge}
            currency={currency}
            lang={lang}
            country={country}
            showLabel={themeConfig?.showLabel}
            isMultiAnswer={question.isMultiAnswer}
            disabled={isDisabled && !isSelected}
            isOutOfStock={isOutOfStock}
            showRelativePrice={question.showRelativePrice}
          />
        )
      })}
    </ScrollableAnswersRow>
  )
}

export default ThumbnailQuestion
